import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    background: theme.palette.bg.main,
    margin: theme.spacing(-4),
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${theme.spacing(8)})`,
  },
  tabContainer: {
    padding: theme.spacing(0, 5),
    borderBottom: `1px solid ${theme.palette.labraV2BoxShadow.dark}`,
    flexShrink: 0,
  },
  content: {
    padding: theme.spacing(4, 5),
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  tabContent: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
}))
